import React from 'react';
import styled from "styled-components";
import {Icon} from "react-materialize";
import {useHistory} from "react-router";

const StyledCustomerBreakdown = styled.div`
  padding-top: 3rem;
  padding-left: 3rem;
  padding-right: 3rem;
  min-height: 60vh;
  width: 100%;
  color: #575757;
  
  .header {
    padding-bottom: 2rem;
    padding-left: 4rem;
    font-size: 3rem;
    position: relative;
    
    i {
      font-size: 4.5rem;
      position: absolute;
      top: 0;
      left: -.1rem;
    }
    
    span {
      text-decoration: underline;
      font-size: 3rem;
      padding-left: 1rem;
      padding-right: 1rem;
      cursor: pointer;
      :hover {
        color: #0B93B9;
      }
    }
  }
  
  .customer-details {
    background-color: #FFFFFF;
    width: 100%;
    min-height: 28rem;
    
    .transaction-type {
      padding-left: 3rem;
      padding-top: 1.5rem;
  
      .date {
        font-size: 2rem;
        color: #8B8B8B;
        letter-spacing: 1px;
      }
    
      .type {
        line-height: 110%;
        font-size: 3rem;
      }
    }
    
    .transaction-breakdown {
      padding-bottom: 1.3rem;
      padding-left: 3rem;
      font-size: 4rem;
      letter-spacing: 3px;
      padding-top: 2rem;
    }
    
      .transaction-stats {
        display: flex;
        padding-top: 1rem;
        
        .stat {
          border-right: 1px solid #575757;
          border-top: 1px solid #575757;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 10.3rem;
          width: 22rem;
          
          .amount {
            font-size: 2.5rem;
          }
        }
      }
  }
`

const CustomerBreakdown = () => {
  let history = useHistory();

  const handleClick = (transaction) => {
    const fakeCustomerId = '5457083d-5157-436c-918c-a8e8a701c98c';
    history.push(`/customers/:id=${fakeCustomerId}`)
  }

  return (
    <StyledCustomerBreakdown>
      <div className={'header'}>
        <Icon>person_outline</Icon>
        <span onClick={handleClick}>Christelle Roberson</span>User Transaction Details
      </div>

      <div className={'customer-details'}>
        <div className={'transaction-type'}>
          <p className={'type'}>Sell BTC</p>
          <p className={'date'}>01/10/18 4:55</p>
        </div>

        <div className={'transaction-breakdown'}>
          Buy BTC > $10,150 USD
        </div>

        <div className={'transaction-stats'}>
          <div className={'stat'}>
            <p className={'amount'}>$7,032</p>
            <p>Cost Basis</p>
          </div>
          <div className={'stat'}>
            <p className={'amount'}>$10,150</p>
            <p>USD Volume</p>
          </div>
          <div className={'stat'}>
            <p className={'amount'}>$3,118</p>
            <p>User Realized Gains</p>
          </div>
          <div className={'stat'}>
            <p className={'amount'}>$150</p>
            <p>Fee</p>
          </div>
        </div>
      </div>
    </StyledCustomerBreakdown>
  )
}

export default CustomerBreakdown;